import { useMemo } from 'react';
import { QueryClientProvider } from 'react-query';
import { extendsQueryClient } from '@/services/queryClient';
import { GlobalState } from '@/hooks/helpers/globalState';
import { Simulator } from '@/Simulator';

const App = (props: any): JSX.Element => {
  const queryClient = useMemo(() => extendsQueryClient(props.queryClient), [props.queryClient]);

  return (
    <QueryClientProvider client={queryClient}>
      <GlobalState.Provider value={props.globalState}>
        <Simulator />
      </GlobalState.Provider>
    </QueryClientProvider>
  );
};

export default App;
